import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-cluster';
import L from 'leaflet';
import { createMapPinIcon, createClusterIcon } from '../../coffee_shops/components/MapPin';
import { RatingBadge } from '../../coffee_shops/components';
import type { CoffeeShop } from '../../coffee_shops/hooks/useCoffeeShops';

interface ShopMarkersLayerProps {
    shops: CoffeeShop[];
}

const ShopMarkersLayer: React.FC<ShopMarkersLayerProps> = ({ shops }) => {
    if (shops.length === 0) return null;

    const createCustomClusterIcon = (cluster: any) => {
        const count = cluster.getChildCount();
        return L.icon({
            iconUrl: createClusterIcon(count),
            iconSize: [Math.min(50, 30 + Math.log(count) * 5), Math.min(50, 30 + Math.log(count) * 5)],
            iconAnchor: [Math.min(25, 15 + Math.log(count) * 2.5), Math.min(25, 15 + Math.log(count) * 2.5)]
        });
    };

    return (
        <MarkerClusterGroup
            chunkedLoading
            iconCreateFunction={createCustomClusterIcon}
            maxClusterRadius={50}
            spiderfyOnMaxZoom
            showCoverageOnHover={false}
        >
            {shops.map((shop) => {
                const icon = L.icon({
                    iconUrl: createMapPinIcon(shop.averageRating ?? 0, false),
                    iconSize: [28, 28],
                    iconAnchor: [14, 14],
                    popupAnchor: [0, -14]
                });
                return (
                    <Marker
                        key={shop._id}
                        position={[shop.coordinates.lat, shop.coordinates.lng]}
                        icon={icon}
                    >
                        <Popup>
                            <div className="min-w-[200px] p-1">
                                <h3 className="font-bold text-base text-ink mb-1">{shop.name}</h3>
                                <p className="text-sm text-muted-foreground mb-1">{shop.address}</p>
                                <div className="flex items-center gap-2">
                                    <RatingBadge rating={shop.averageRating ?? 0} size="sm" showMax={false} />
                                    <span className="text-xs text-muted-foreground">
                                        {shop.totalRatings} ratings
                                    </span>
                                </div>
                            </div>
                        </Popup>
                    </Marker>
                );
            })}
        </MarkerClusterGroup>
    );
};

export default ShopMarkersLayer;
